import { Component, Inject, OnDestroy } from '@angular/core';
import { BusDataRetrievalService } from 'src/app/services/apiHandler/bus-data-retrieval/bus-data-retrieval.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/helper/global-helper';



interface CAN {
  name: string;
  busNumber: number[];
  canIds: number[];
  state: number[];
}

interface TableData {
  can: number;
  member_id: number;
  state: string;
}

@Component({
  selector: 'app-bus-visualization',
  templateUrl: './bus-visualization.component.html',
  styleUrls: ['./bus-visualization.component.scss']
})
export class BusVisualizationComponent implements OnDestroy{

  public busData: any;
  public loaded: boolean = false;
  public count: number[] = [];
  public refData: CAN[] = [];
  private subscription: any;
  public errorMessage: string = "";
  public noConnection: boolean = false;
  public filled: boolean = false;
  public timer: any;

  public stateList = ["BUS.DEFINE","BUS.OKAY", "BUS.ERROR", "BUS.REACH"];

  constructor(private busDataService: BusDataRetrievalService, public gatewayConnectionService: GatewayConnectionService,public dialog: MatDialog, private translate: TranslateService){
    this.gatewayConnectionService.checkGatewayAlive().subscribe({
      next: (isAlive) => {
        if(isAlive){
          this.sendRequest();
        }
      }
    });
  }

  ngOnDestroy(){
    clearTimeout(this.timer);
    if(this.subscription != undefined){
      this.subscription.unsubscribe();
    }
  }

  private sendRequest(){
    this.subscription = this.busDataService.getBusTopology().subscribe((response) => {
      this.refData = [];
      this.busData = response.body;
      this.loaded = true;
      if(response.status === 200){
        this.fillData();
      }
    });
  }

  public cancelRequest() {
    this.subscription.unsubscribe();
    this.errorMessage = this.translate.instant('MESSAGES.CHECK_CONN');
    this.noConnection = true;
  }

  public fillData(){
    let minBus = this.findMinCanBus();
    // fill counter array
    for(let i = 0; i < this.busData.canBusCount; i++){
      this.count[i] = i + minBus!;
    } 
    // sort data by name
    let name: String[] = [];
    let count = 0;
    for(let item of this.busData.participants){
      count++;
      if(!name.includes(item.name)){
        name.push(item.name)
        // dirty fix for linebreak for joystick left name 
        if(item.name.toString() == "Joystick links") {
          item.name = "\xa0\xa0Joystick\xa0" + " \xa0links";
        }
        this.refData.push({name: item.name, busNumber: [item.canBus], canIds: [item.canId], state: [item.canState] });
      } else {
        let indexToUpdate = this.refData.findIndex(module => module.name === item.name);
        let busNumber = this.refData[indexToUpdate].busNumber;        
        if(!busNumber.includes(item.canBus)){
          busNumber.push(item.canBus);
        }
        let canIds = this.refData[indexToUpdate].canIds;
        canIds.push(item.canId);
        let state = this.refData[indexToUpdate].state;
        state.push(item.canState);
        let newItem: CAN = {name: item.name, busNumber: busNumber, canIds: canIds, state: state };
        this.refData[indexToUpdate] = newItem;
      }
      if(count === this.busData.participants.length){
        this.filled = true;
      }
    }
    this.triggerReload();
  }

  private findMinCanBus() {
    if(!this.busData.participants || this.busData.participants.length === 0) {
      return null;
    }
    return Math.min(...this.busData.participants.map((p: { canBus: any; }) => p.canBus));
  }

  public triggerReload(){
    this.timer = setTimeout(() => {
      this.sendRequest();
    }, 2000);
    
  }

  public openDialog(item: CAN){
    this.dialog.open(BusSpecificDialog, {
      width: '50%',
      data: item,
    });
  }

}

// Dialog
@Component({
  selector: 'bus-specific-dialog',
  templateUrl: 'bus-specific-dialog.html',
  styleUrls: ['./bus-specific-dialog.scss']
})
export class BusSpecificDialog {

  dataSource: TableData[] = [];
  displayColumns: string[] = ["can", "member_id", "state"];

  ecus = this.global.canToIoEcus; //['Master ECU OBW', 'Slave ECU OBW', 'Slave ECU Kabine'];
  dtcEcus = this.global.canToDtcEcus; //['Master ECU OBW', 'Slave ECU OBW', 'Slave ECU Kabine', 'Motor Cummins'];


  constructor(@Inject(MAT_DIALOG_DATA) public data: CAN, private dialogRef: MatDialogRef<BusSpecificDialog>, private router: Router, private global: GlobalService) {
    for(let i = 0; i < data.busNumber.length; i++) {
      let state = "";
      switch (data.state[i]) {
        case 0:
          state = "not definable";
          break;
        case 1:
          state = "okay";
          break;
        case 2:
          state = "error on can-member";
          break;
        case 3:
          state = "not reachable";
          break;
        default:
          state = "not definable";
      }
      this.dataSource.push({can: data.busNumber[i], member_id: data.canIds[i] ,state: state})
    }
  }

  routToIO(data: number[]){
    this.global.io.next({expanded_id: data[0]});
    this.router.navigate(['/ioOverview']);
    this.dialogRef.close();
  }

  routToDtc(data: number[]){
    this.global.io.next({dtc_ecu: data[0]});
    this.router.navigate(['/dtc']);
    this.dialogRef.close();
  }

}
